import { render, staticRenderFns } from "./joinSet.vue?vue&type=template&id=14072816&scoped=true"
import script from "./joinSet.vue?vue&type=script&lang=js"
export * from "./joinSet.vue?vue&type=script&lang=js"
import style0 from "./joinSet.vue?vue&type=style&index=0&id=14072816&prod&lang=css"
import style1 from "./joinSet.vue?vue&type=style&index=1&id=14072816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14072816",
  null
  
)

export default component.exports